import _objectSpread from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import meetingApi from '@/services/meeting';
import MeetingDetail from '@/components/meeting/MeetingDetail.vue';
export default {
  name: 'MyApplication',
  components: {
    MeetingDetail: MeetingDetail
  },
  data: function data() {
    var _this = this;
    return {
      searchForm: {
        id: '',
        meetingName: '',
        roomId: ''
      },
      roomList: [],
      reservationList: [],
      loading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50'],
        onShowSizeChange: function onShowSizeChange(current, pageSize) {
          _this.pagination.pageSize = pageSize;
          _this.search();
        },
        onChange: function onChange(current) {
          _this.pagination.current = current;
          _this.search();
        }
      },
      detailVisible: false,
      selectedId: null
    };
  },
  created: function created() {
    this.loadRooms();
    this.search();
  },
  methods: {
    loadRooms: function loadRooms() {
      var _this2 = this;
      meetingApi.queryRoomList().then(function (res) {
        if (res.data && res.data.code === 200) {
          _this2.roomList = res.data.data;
        }
      });
    },
    search: function search() {
      var _this3 = this;
      this.loading = true;
      var params = _objectSpread(_objectSpread({}, this.searchForm), {}, {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      });

      // 调用真实接口获取数据
      meetingApi.queryMyReservationList(params).then(function (res) {
        if (res.data && res.data.code === 200) {
          _this3.reservationList = res.data.rows || [];
          _this3.pagination.total = res.data.total || 0;
        } else {
          _this3.reservationList = [];
          _this3.pagination.total = 0;
          _this3.$message.error(res.data.message || '获取数据失败');
        }
      }).catch(function (err) {
        _this3.reservationList = [];
        _this3.pagination.total = 0;
        _this3.$message.error('获取数据失败');
      }).finally(function () {
        _this3.loading = false;
      });
    },
    reset: function reset() {
      this.searchForm = {
        id: '',
        meetingName: '',
        roomId: ''
      };
      this.search();
    },
    viewDetail: function viewDetail(record) {
      var _this4 = this;
      this.selectedId = record.id;
      this.detailVisible = true;
      // 强制刷新数据，即使id不变
      this.$nextTick(function () {
        if (_this4.$refs.meetingDetail) {
          _this4.$refs.meetingDetail.loadDetail(record.id);
        }
      });
    },
    cancelRecord: function cancelRecord(record) {
      var _this5 = this;
      this.$confirm('确定要撤销这条预约申请吗？', '确认撤销', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        meetingApi.cancelReservation({
          id: record.id
        }).then(function (res) {
          if (res.data && res.data.code === 200) {
            _this5.$message.success('撤销成功');
            _this5.search();
          } else {
            _this5.$message.error(res.data.message || '撤销失败');
          }
        }).catch(function (err) {
          _this5.$message.error('撤销失败');
        });
      }).catch(function () {
        // 用户点击取消，不做任何操作
      });
    },
    editRecord: function editRecord(record) {
      this.$router.push({
        path: '/meeting/meetingRoom/meetingRoomCreate',
        query: {
          reservationId: record.id
        }
      });
    },
    getStatusText: function getStatusText(status) {
      var statusMap = {
        'DRAFT': '草稿',
        'PENDING_APPROVAL': '待审批',
        'APPROVED': '审批中',
        'REJECTED': '已拒绝',
        'END': '已通过',
        'CANCELLED': '已取消'
      };
      return statusMap[status] || status;
    },
    getStatusColor: function getStatusColor(status) {
      var colorMap = {
        'DRAFT': 'cyan',
        'PENDING_APPROVAL': 'orange',
        'APPROVED': 'green',
        'END': 'purple',
        'REJECTED': 'red',
        'CANCELLED': 'gray'
      };
      return colorMap[status] || 'default';
    }
  },
  computed: {
    columns: function columns() {
      return [{
        title: '流水号',
        dataIndex: 'id',
        key: 'id',
        width: 100
      }, {
        title: '会议标题',
        dataIndex: 'meetingName',
        key: 'meetingName',
        ellipsis: true
      }, {
        title: '会议室',
        dataIndex: 'room',
        key: 'room',
        width: 120
      }, {
        title: '申请时间',
        dataIndex: 'createTime',
        key: 'createTime',
        width: 180
      }, {
        title: '办理状态',
        dataIndex: 'status',
        key: 'status',
        width: 100,
        scopedSlots: {
          customRender: 'status'
        }
      }, {
        title: '操作',
        key: 'action',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }];
    }
  }
};